import { ComplaintClient } from './complaint-client.model';

import { ComplaintClientRepresentative } from './complaint-client-representative.model';

import { ComplaintAddress } from './complaint-address.model';

import { ComplaintSimpleAddress } from './complaint-simple-address.model';
import { ComplaintBookBill } from './complaint-book-bill.model';
import { EmailNotification } from './complaint-email-notification.model';
import { ComplaintBill } from './complaint-bill.model';
import { ComplaintConcept } from './complaint-concept.model';

/**Libro de reclamaciones */
export class ComplaintBook {
    public tipoBien: string;
    public descripcionTipoBien: string;
    public isNotification: string;
    public notificacionInput: string;
    public indicadorTitular: string;
    /**Código de sub motivo */
    public subReasonCode: string;
    public subMotivo: string;
    /**Código de motivo */
    public reasonCode: string;
    public motivo: string;
    /**Tipo de incidencia */
    public type: string;
    /**Descripción de reclamo */
    public description: string;
    /**Cliente */
    public client: ComplaintClient;
    /**Datos de representante de cliente */
    public clientRepresentative: ComplaintClientRepresentative;
    /**Dirección de cliente */
    public clientAddress: ComplaintAddress;
    /**Primera dirección de notificación */
    public firstNotificationAddress: string;
    /**Segunda dirección de notificación */
    public secondNotificationAddress: ComplaintSimpleAddress;
    /**Lista de recibos */
    public billList: ComplaintBill[];
    /**Email de notificación */
    public emailAddressNotification?: EmailNotification;

    public captchaV3?: string;

    public ComplaintConcepto: ComplaintConcept[];


}